export const LEFT_Px = 111;
export const MIDLEFT_Px = 259;
export const MID_Px = 332;
export const MIDRIGHT_Px = 405;
export const RIGHT_Px = 553;

export const TOP_Px = 0;
export const SECOND_Px = 61;
export const BOTTOM_Px = 380;

export const ToleranceImageMaxWidthPx = 670;

export const CLEAR_PIXEL =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/wcAAgAB/1hDkAAAAABJRU5ErkJggg==';
